import React, { useId } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useStyles as classes } from '../styles/styles';

const Popup = (props) => {
    const open = props.open;
    const setDone = props.setDone;
    const component = props.component;
    const maxWidth = props.maxWidth;
    const title = props.title || "Dialog Title";
    // MUI's Dialog runs aria-labelledby through useId, so leaving it unset does
    // not omit the attribute -- it generates an id that only a DialogTitle would
    // claim. This dialog has no DialogTitle (CPDEV-2762 replaced it with the
    // paper aria-label below), so the reference dangled. Naming the id here and
    // pointing it at real hidden text makes it resolve.
    const titleId = useId();

    return (
        <>
            <Dialog
                open={open}
                maxWidth={maxWidth ? maxWidth : 'md'}
                fullWidth
                sx={{...classes.dialog, backgroundColor: 'transparent'}}
                scroll="paper"
                aria-labelledby={titleId}
                // No aria-describedby (CPDEV-2842): a description is read in one
                // flat run when the dialog opens, and these bodies are whole
                // notices and terms -- headings, paragraphs, lists. Screen reader
                // users now hear the title and read the body in its own structure.
                tabIndex="-1"
                aria-modal="true"
                onClose={() => setDone(true)}
                slotProps={{
                    paper: {
                        'aria-label': title
                    },
                    backdrop: {
                        'aria-hidden': 'true'
                    }
                }}
            >
                <span id={titleId} style={classes.visuallyHidden}>{title}</span>
                <DialogContent dividers>
                    <DialogContentText component="div">
                        {component}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDone(true)}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default Popup;
